import { ALL_SOURCES } from './mappable-params';
import type {
  ConfidenceBand,
  MappingSuggestionsParams,
  SuggestionView,
} from './suggestion-types';

export const SUGGESTIONS_PAGE_SIZE = 50;

/** The "no filter" choice of the connection and confidence selects. */
export const ANY = ALL_SOURCES;

export type SuggestionFilter = {
  page: number;
  search: string;
  connectionId: string;
  band: ConfidenceBand | typeof ANY;
  /** Also the Inactive / ARCHIVED / UNLISTED listings (M2). */
  showInactive: boolean;
};

export const initialSuggestionFilter: SuggestionFilter = {
  page: 1,
  search: '',
  connectionId: ANY,
  band: ANY,
  showInactive: false,
};

/** The query for a view; the band is set by the caller that fetches one band only. */
export function buildSuggestionParams(
  view: SuggestionView,
  filter: SuggestionFilter,
  overrides: Partial<MappingSuggestionsParams> = {},
): MappingSuggestionsParams {
  const params: MappingSuggestionsParams = {
    view,
    page: filter.page,
    limit: SUGGESTIONS_PAGE_SIZE,
    search: filter.search.trim(),
  };

  if (filter.connectionId !== ANY) {
    params.connectionId = filter.connectionId;
  }

  if (filter.band !== ANY) {
    params.band = filter.band;
  }

  if (filter.showInactive) {
    params.showInactive = true;
  }

  return { ...params, ...overrides };
}
